import React, { useEffect, useMemo, useState } from "react";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/DataTableContainer';
import { Button } from "reactstrap";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "components/Modals/ConfirmationModal";
import { deleteCustomerRequest } from "store/actions";
import { MdDeleteOutline } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";

const CustomerTable = ({ List, loading, totalCount, pageIndex, pageSize, sorting, onPaginationChange, onSortingChange }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false);
  const [deleteId, setDeleteId] = useState(false);
  const [confirmAction, setConfirmAction] = useState(false);

  const permissions = JSON.parse(localStorage?.getItem('permissions'));

  const hasEditPermission = permissions.some(item => item?.permissionName === "Edit Customers");
  const hasDeletePermission = permissions.some(item => item?.permissionName === "Delete Customers");


  const handleDelete = (customerId) => {
    dispatch(deleteCustomerRequest(customerId)); // Dispatch delete action for customer
    setDeleteId('');
    setOpenModal(false);
    setConfirmAction(false);
  };

  useEffect(() => {
    if (deleteId && confirmAction) {
      handleDelete(deleteId);
    }
  }, [deleteId, confirmAction]);

  const columns = useMemo(
    () => [
      {
        header: 'Customer Name (Eng)',
        accessorKey: 'customerNameEng',

        showFilter: true,

        cell: ({ row }) => {
          const permissionNames = permissions?.map(item => item?.permissionName) || [];
          const canClick = permissionNames.includes("View Customer Profile");
          // permissionNames.includes("Edit Customers") ||
          // permissionNames.includes("Add Customers");
          return canClick ? (
            <span
              title="View Profile"
              style={{ cursor: 'pointer', color: "#04a1b6" }}
              onClick={() => navigate(`/customerProfile/${row.original.customerId}`)}
            >
              {row.original.customerNameEng}
            </span>
          ) : (
            <span style={{ color: "#666" }}>
              {row.original.customerNameEng}
            </span>
          );

        },
      },
      {
        header: 'Customer Name (Ar)',
        accessorKey: 'customerNameAr',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Contract Number',
        accessorKey: 'contractNumber',
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: 'Civil ID',
        accessorKey: 'contractId',
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: 'Subscriber Number',
        accessorKey: 'subscriberNumber',
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: 'Contact Number 1',
        accessorKey: 'contactNumber1',
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: 'Contact Number 2',
        accessorKey: 'contactNumber2',
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ getValue }) => getValue() ? getValue() : 'N/A',
      },
      {
        header: 'Nationality',
        accessorKey: 'nationality1',
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: 'Status',
        accessorKey: 'isActive',
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ getValue }) => getValue() ? 'Active' : 'Inactive',
      },
      ...(hasEditPermission || hasDeletePermission ? [{
        header: 'Actions',
        id: 'actions', // Unique id for this column
        enableSorting: false,
        cell: ({ row }) => {
          const handleEdit = () => {
            const rowData = row.original;
            navigate(`/createCustomer?id=${rowData?.customerId}`, { state: { from: window.location.pathname } });
            // You can handle the edit functionality here
            console.log('Edit clicked for row:', rowData);
          };

          return (
            <div className="d-flex gap-2 ">
              {permissions?.map(item => item?.permissionName)?.includes("Edit Customers") && <Button color="primary" onClick={handleEdit} className="mr-2">
                <FaRegEdit size={18} />
              </Button>}
              {permissions?.map(item => item?.permissionName)?.includes("Delete Customers") && <Button
                color="danger"
                onClick={() => { setDeleteId(row?.original?.customerId); setOpenModal(true); }}
                className="mr-2"
              >
                <MdDeleteOutline size={18} />
              </Button>}
            </div>
          );
        },
      },
      ] : []),
    ],
    [hasEditPermission, hasDeletePermission]
  );

  //meta title
  document.title = "Customer Data | Your Admin Dashboard";

  return (
    <>
      <ConfirmationModal
        okText={"Confirm"}
        onCancel={() => { setDeleteId(''); setOpenModal(false); }}
        onOk={() => { setConfirmAction(true); }}
        isVisible={openModal}
        title="Delete Customer"
        content="Are you sure you want to delete this customer?"
      />
      <div className="">
        <div className="container-fluid">
          {/* <Breadcrumbs title="Tables" breadcrumbItem="Customer Data" /> */}

          <TableContainer
            loading={loading}
            columns={columns}
            data={List || []}
            isGlobalFilter={false}
            manualPagination={true}
            manualSorting={true}
            manualFiltering={true}
            totalCount={List && List.length > 0 ? List[0]?.TotalCount : totalCount}
            pageCount={List && List.length > 0 ? Math.ceil(List[0]?.TotalCount / pageSize) : Math.ceil(totalCount / pageSize)}
            paginationState={{ pageIndex, pageSize }}
            sortingState={sorting}
            onPaginationChange={onPaginationChange}
            onSortingChange={onSortingChange}
            isPagination={true}
            SearchPlaceholder="Search..."
            pagination="pagination"
            docName="Customers"
            paginationWrapper='dataTables_paginate paging_simple_numbers'
            tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          />
        </div>
      </div>
    </>
  );
};

export default CustomerTable;
